import { CompanyAPI } from '@api';

const createBus = (form) => CompanyAPI.createBus(form)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { createBus };
